import apiUseCases from "@src/cloud-connect/api";
import { PostCheckMachineAvailabilityResponse } from "@src/cloud-connect/api/client-configuration/post-check-machine-availability";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface CheckMachineAvailabilityResult {
  success: boolean;
  data?: PostCheckMachineAvailabilityResponse;
  error?: string;
  errorData?: unknown;
  status?: number;
}

export const checkMachineAvailabilityUseCase = async (
  gatewayId: string,
  hostname: string,
): Promise<CheckMachineAvailabilityResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postCheckMachineAvailability(namespace, {
      gateway_id: gatewayId,
      hostname,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    const parsed = parseAxiosApiError(
      error,
      "Failed to check machine availability.",
    );

    return {
      success: false,
      error: parsed.message,
      errorData: parsed.data,
      status: parsed.status,
    };
  }
};
